<!-- @format -->

<a
	*ngIf="data && data.link !== 'na'"
	[href]="data.link"
	[attr.data-em]="createTag(spotNumber, data.headline, data.Subhead)">
	<div>
		<shared-media-component-media
			*ngIf="data.Scene7ImagePath || data.visualAssets"
			[visualAssets]="data.visualAssets"
			[imageWidthParam]="imageWidthParam"
			[image]="data.Scene7ImagePath"
			[itemTitle]="data.headline || data.Subhead"
			[altText]="data.altText"
			[willLazyLoad]="true"
			[imagePagePosition]="5">
		</shared-media-component-media>
		<strong
			*ngIf="data.badgeText && data.badgeText !== 'na'"
			[innerHTML]="data.badgeText"></strong>
	</div>

	@if (data?.headline && data?.headline !== 'na') {
		<h2>{{ data.headline }}</h2>
	}
	<p
		*ngIf="data.Subhead !== 'na'"
		[innerHTML]="data.Subhead"></p>
	<button
		hmf-button
		*ngIf="data.cta[0] && data.cta[0].link !== 'na' && data.cta[0].linkTitle !== 'na'"
		height="base"
		variant="tertiary"
		[href]="data.cta[0].link"
		[attr.target]="targetService(data.cta[0].link)"
		[text]="data.cta[0].linkTitle"
		[dataEm]="createTag(spotNumber, data.headline, data.cta[0].linkTitle)"></button>
</a>
